import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.assign.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cloneDeep from 'lodash/cloneDeep';
import Logger from 'js-logger';
import { make } from 'vuex-pathify';
import moment from 'moment';
import { i18n } from '@/boot/i18n';
import { FIB } from '@/config/constants';
import { hash } from '@/functions/utils';
import { precacheUrls, clearCaches } from '@/utils/sw';
var US = FIB.US; // Use constants for Update States

var defaultState = function defaultState() {
  return {
    branchDetails: null,
    branchId: null,
    // cachedAssets: [],
    cachedStaff: [],
    cachedTheme: [],
    companyKey: null,
    config: null,
    // Config data
    configTemp: null,
    // Temporary storage for downloaded config data
    deviceId: null,
    lastUpdated: null,
    // Timestamp of last download
    menuItemsLastUpdated: null,
    nextSync: null,
    // Timestamp of next scheduled sync
    passcode: null,
    registered: false,
    settingsPasscode: null,
    updateState: US.UNKNOWN,
    // Config update state
    uuid: null,
    // Device fingerprint
    // Are automation tools enabled? Default automationEnabled to be on when automation is available.
    automationEnabled: process.env.ALLOW_AUTOMATION
  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Attempt to change the settings passcode
   *
   * @param {Object} context Vuex module context
   * @param {String} passcode New settings passcode
   *
   * @returns {Object}
   */
  changeSettingsPasscode: function changeSettingsPasscode(_ref, passcode) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var state;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref.state;
              _context.next = 3;
              return _this.$api.changeSettingsPasscode({
                configuration: {
                  settingsPasscode: passcode
                },
                pass: hash((state.deviceId || '').toUpperCase() + state.passcode),
                uuid: state.uuid
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Attempt to deregister a device using values from the store.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Object}
   */
  deregisterDevice: function deregisterDevice(_ref2) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var state;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref2.state;
              _context2.next = 3;
              return _this2.$api.deregisterDevice({
                pass: hash((state.deviceId || '').toUpperCase() + state.passcode),
                uuid: state.uuid
              });

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Download config data into the store
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True when successful, false otherwise
   */
  fetchConfig: function fetchConfig(_ref3) {
    var _arguments = arguments,
        _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, dispatch, rootState, getters, settingsDownload, edges, config, staffDownloaded, menuItems, removeUrls, googleFonts, staff, staffUrls;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit, dispatch = _ref3.dispatch, rootState = _ref3.rootState, getters = _ref3.getters;
              settingsDownload = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;

              if (rootState.settings.hasConnectivity) {
                _context3.next = 6;
                break;
              }

              Logger.warn('Cannot fetch config while offline, will retry when online'); // Try again when we're back online

              commit('settings/updateWhenOnline', true, {
                root: true
              });
              return _context3.abrupt("return", false);

            case 6:
              // Start the config download
              Logger.debug('Start config download (Config)');
              commit('updateState', US.IN_PROGRESS);
              edges = ['branch', 'complaints', 'core', 'data_capture', 'demographics', 'statics'];

              if (getters.isApp) {
                edges.push('staff');
              }

              _context3.next = 12;
              return _this3.$api.fetchConfig(edges);

            case 12:
              config = _context3.sent;
              Logger.debug('Download result:', config);

              if (!(!config || config.error)) {
                _context3.next = 20;
                break;
              }

              Logger.warn('Failed to download config');
              commit('updateState', US.PENDING);
              return _context3.abrupt("return", false);

            case 20:
              // commit('updateState', US.DONE) // Not done yet, get staff too
              // set branch details to allow checkin to progress
              commit('branchDetails', config.data.branch);

            case 21:
              // Start the staff download
              Logger.debug('Start staff download');
              _context3.next = 24;
              return dispatch('manageTeam/fetchTeamMembers', {}, {
                root: true
              });

            case 24:
              staffDownloaded = _context3.sent;
              Logger.debug('Download result:', staffDownloaded);

              if (staffDownloaded) {
                _context3.next = 32;
                break;
              }

              Logger.warn('Failed to download staff');
              commit('updateState', US.PENDING);
              return _context3.abrupt("return", false);

            case 32:
              commit('updateState', US.DONE);

            case 33:
              if (!(getters.isApp && !settingsDownload)) {
                _context3.next = 43;
                break;
              }

              _context3.next = 36;
              return dispatch('products/exportMenuData', null, {
                root: true
              });

            case 36:
              menuItems = _context3.sent;

              if (menuItems) {
                _context3.next = 42;
                break;
              }

              commit('updateState', US.PENDING);
              return _context3.abrupt("return", false);

            case 42:
              commit('updateState', US.DONE);

            case 43:
              // Save the config data
              Logger.debug('Save config');
              commit('configTemp', config.data); // App specific caching for offline resources

              if (!(process.env.MODE === 'pwa' || process.env.APP_FOR_WEB)) {
                _context3.next = 63;
                break;
              }

              removeUrls = [];
              /**
               * Cache asset urls
               */

              /*
              const assetUrls = []
              assetUrls.push('statics/icons/settings.svg')
               // Compare current URLs with previously cached URLs to determine which to clear from cache
              removeUrls.length = 0 // Empty the array
              state.cachedAssets.forEach(url => {
                if (!assetUrls.includes(url)) removeUrls.push(url)
              })
               // Clear cache of old asset urls
              Logger.debug(`Removing ${removeUrls.length} asset url(s) from cache:`, removeUrls)
              if (removeUrls.length) clearCaches(removeUrls)
               // Pre-cache new/existing asset urls
              Logger.debug(`Pre-caching ${assetUrls.length} asset url(s)`)
              await precacheUrls(assetUrls)
               // Store cached asset urls for comparison next time
              Logger.debug('Cached asset url(s):', assetUrls)
              commit('cachedAssets', assetUrls)
              */

              /**
               * Cache Google fonts
               */

              googleFonts = ['https://fonts.googleapis.com/css?family=Poppins', 'https://fonts.googleapis.com/css?family=Poppins|Raleway|Open+Sans|Montserrat|Alegreya+Sans|Rubik', 'https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2']; // Clear cache of old google fonts

              if (googleFonts.length) {
                clearCaches(googleFonts);
              } // Pre-cache new/existing google fonts


              _context3.next = 51;
              return precacheUrls(googleFonts);

            case 51:
              /**
               * Cache staff urls
               */
              staff = rootState.manageTeam.teamData.teamMembers;
              staffUrls = [];
              staff.forEach(function (member) {
                // staffUrls.push(member.imageUrl) // <- This one could eat up our available storage space
                staffUrls.push(member.thumbnailUrl);
              }); // Compare current URLs with previously cached URLs to determine which to clear from cache

              removeUrls.length = 0; // Empty the array

              state.cachedStaff.forEach(function (url) {
                if (!staffUrls.includes(url)) {
                  removeUrls.push(url);
                }
              }); // Clear cache of old staff urls

              Logger.debug("Removing ".concat(removeUrls.length, " staff url(s) from cache:"), removeUrls);

              if (removeUrls.length) {
                clearCaches(removeUrls);
              } // Pre-cache new/existing staff urls


              Logger.debug("Pre-caching ".concat(staffUrls.length, " staff url(s)"));
              _context3.next = 61;
              return precacheUrls(staffUrls);

            case 61:
              // Store cached staff urls for comparison next time
              Logger.debug('Cached staff url(s):', staffUrls);
              commit('cachedStaff', staffUrls);

            case 63:
              // Set last updated timestamp
              commit('lastUpdated', moment().unix()); // Move config data out of temporary storage if a survey is not in progress

              if (!rootState.surveys.surveyInProgress) {
                dispatch('moveData');
              }

              return _context3.abrupt("return", true);

            case 66:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  commitConfig: function commitConfig(_ref4, data) {
    var _;

    var commit = _ref4.commit;
    commit('config', data); // i18n.locale = data?.surveys[0]?.templateLocale || 'en-gb';

    i18n.locale = ((_ = ((data === null || data === void 0 ? void 0 : data.surveys) || [])[0]) === null || _ === void 0 ? void 0 : _.templateLocale) || 'en-gb';
  },

  /**
   * Move config data out of temporary storage into main storage.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Void}
   */
  moveData: function moveData(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    if (!state.configTemp) {
      Logger.debug('No temporary config data to move');
      return;
    }

    Logger.debug('Move config data out of temporary storage');
    var temp = state.configTemp;
    commit('configTemp', null);
    dispatch('commitConfig', temp);
  },

  /**
   * Attempt to register a device using values from the store.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Object}
   */
  registerDevice: function registerDevice(_ref6) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var state, rootState;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref6.state, rootState = _ref6.rootState;
              _context4.next = 3;
              return _this4.$api.registerDevice({
                configuration: {
                  settingsPasscode: rootState.settings.passcode
                },
                pass: hash((state.deviceId || '').toUpperCase() + state.passcode),
                uuid: state.uuid
              });

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Set the branch by a field
   * @param {Object} context Vuex module context
   * @param {Object} Params {id: id, field: 'id|locationId|siteId'}
   *
   * @returns {Object}
   */
  setBranchByField: function setBranchByField(_ref7, _ref8) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _rootState$checkIn;

      var commit, dispatch, rootState, id, _ref8$field, field, branchDetails, _rootState$checkIn2, _rootState$checkIn2$u;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref7.commit, dispatch = _ref7.dispatch, rootState = _ref7.rootState;
              id = _ref8.id, _ref8$field = _ref8.field, field = _ref8$field === void 0 ? 'id' : _ref8$field;

              if (!(!id || !['id', 'locationId', 'siteId'].includes(field))) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return");

            case 4:
              if (field == 'id') {
                id = parseInt(id);
              }

              if ((_rootState$checkIn = rootState.checkIn) !== null && _rootState$checkIn !== void 0 && _rootState$checkIn.branches || null) {
                _context5.next = 8;
                break;
              }

              _context5.next = 8;
              return _this5.dispatch('checkIn/fetchBranches', '', {
                root: true
              });

            case 8:
              branchDetails = rootState.checkIn.branches.find(function (branch) {
                return branch[field] == id;
              });

              if (!branchDetails) {
                _context5.next = 17;
                break;
              }

              if (!(((_rootState$checkIn2 = rootState.checkIn) !== null && _rootState$checkIn2 !== void 0 && (_rootState$checkIn2$u = _rootState$checkIn2.urlParams) !== null && _rootState$checkIn2$u !== void 0 && _rootState$checkIn2$u.inBranch || false) && rootState.checkIn.urlParams.inBranch !== branchDetails.hashCode)) {
                _context5.next = 12;
                break;
              }

              return _context5.abrupt("return");

            case 12:
              commit('setBranchId', branchDetails.id);
              commit('setBranchDetails', branchDetails);
              _context5.next = 16;
              return dispatch('checkIn/fetchBranchConfig', (rootState.checkIn.urlParams || {}).slug, {
                root: true
              });

            case 16:
              return _context5.abrupt("return", branchDetails);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * Get branch details and return if available
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Void}
   */
  getBranchDetails: function getBranchDetails(state) {
    if (!state.branchId) {
      return null;
    }

    var branchDetails = cloneDeep(state.branchDetails) || {};
    branchDetails.id = state.branchId;
    return branchDetails;
  },

  /**
   * Get demographic data from config.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array} Array of demographic types
   */
  getDemographics: function getDemographics(state) {
    var config = state.config;
    return config && config.demographics && Array.isArray(config.demographics.types) ? cloneDeep(config.demographics.types) : [];
  },

  /**
   * Calculate device type.
   *
   * @returns {String} device type
   */
  getDeviceType: function getDeviceType() {
    return process.env.MODE === 'pwa' || process.env.APP_FOR_WEB ? 'app' : 'web';
  },

  /**
   * Returns true if context infers that we're running as 'app', else false if as 'web'
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Boolean}
   */
  isApp: function isApp(state, getters) {
    return getters.getDeviceType === 'app';
  },

  /**
   * Get the synchronisation schedule from state.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Object} Synchronisation schedule
   */
  syncSchedule: function syncSchedule(state) {
    try {
      // Return the first (there should only be one) `sync` item
      var _state$config$core$sc = state.config.core.schedules.filter(function (item) {
        return item.what === 'sync';
      })[0],
          what = _state$config$core$sc.what,
          when = _state$config$core$sc.when,
          spread = _state$config$core$sc.spread;
      var sync = {
        what: what,
        when: when,
        spread: spread
      };
      Logger.debug('' + 'Using sync values from API:', sync);
      return sync;
    } catch (e) {
      // Use default values if there's a problem
      var _sync = {
        what: 'sync',
        when: '20 5 * * *',
        spread: 1800
      };
      Logger.debug('Failed to read sync values from API, using default values:', _sync);
      return _sync;
    }
  },

  /**
   * Team pins enabled
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Boolean} Whether team pins are enabled for the branch
   */
  teamPinsEnabled: function teamPinsEnabled(state) {
    return state.config && (state.config.branch || {}).enableStaffPinCodes || false;
  },
  getCompanyDetails: function getCompanyDetails(state) {
    var _state$config, _state$config$core;

    return (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$core = _state$config.core) === null || _state$config$core === void 0 ? void 0 : _state$config$core.company;
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * @param {Object} state Vuex module state
   * @param {Object} payload
   */
  setBranchDetails: function setBranchDetails(state, payload) {
    //Logger.debug('setBranchDetails: ', payload)
    state.branchDetails = payload;
  },

  /**
   * @param {Object} state Vuex module state
   * @param {Int} branchId
   */
  setBranchId: function setBranchId(state, branchId) {
    state.branchId = branchId;
  },

  /**
   * @param {Object} state Vuex module state
   * @param {Bool} enable
   */
  configureAutomation: function configureAutomation(state, enable) {
    state.automationEnabled = enable;
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};